import { render, staticRenderFns } from "./SharedServices.vue?vue&type=template&id=88a61e50&scoped=true"
import script from "./SharedServices.vue?vue&type=script&lang=js"
export * from "./SharedServices.vue?vue&type=script&lang=js"
import style0 from "./SharedServices.vue?vue&type=style&index=0&id=88a61e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a61e50",
  null
  
)

export default component.exports